import { defineStore } from "pinia"
import { ContactRole } from "@/shared/models/contact-role"
import { ContactRoleService } from "@/shared/services/contact-role"
import { TableState } from "@/shared/models/table"
import { GgmsError } from "@/shared/services/client"

export const useContactRoleStore = defineStore("contactRole", {
    state: () => ({
        tableState: {
            data: [],
            selectedData: [],
            currentPage: 0,
            lastPage: 0,
            pageLength: 50,
            numberOfPages: 0,
            total: 0,
            isAllSelected: false,
            isLoading: false,
            error: {} as GgmsError,
            search: "",
            firstIds: [],
        } as TableState<ContactRole>,
        contactRoleService: new ContactRoleService(),
        cachedRoles: {} as Record<string, ContactRole>,
    }),
    actions: {
        async getAll() {
            this.tableState.isLoading = true
            try {
                const response = await this.contactRoleService.getAll({
                    search: this.tableState.search,
                })
                this.tableState.data = response.data
                this.tableState.data.forEach((role) => {
                    this.cachedRoles[role._id] = role
                })
            } catch (error) {
                this.tableState.error = error as GgmsError
            } finally {
                this.tableState.isLoading = false
            }
        },

        async getCachedRoles() {
            const response = await this.contactRoleService.getCachedRoles()
            if (response) {
                response.data.forEach((role) => {
                    this.cachedRoles[role._id] = role
                })
            } else {
                this.cachedRoles = {}
            }
        },
    },
})
